import type { LineDirection } from "@/elements/arrow/types";

export class QuadraticLine {
    constructor(startX: number, startY: number, endX: number, endY: number, type: LineDirection) {
        this.startX = startX;
        this.startY = startY;
        this.endX = endX;
        this.endY = endY;
        this.type = type;

        this.length = Math.sqrt(
            (this.endX - this.startX) * (this.endX - this.startX) +
                (this.endY - this.startY) * (this.endY - this.startY),
        );
    }

    startX = 0;
    startY = 0;
    endX = 0;
    endY = 0;
    length = 0;
    type: LineDirection = "horizontal";
    potencial: { x: number; y: number; xCreate: number; yCreate: number } = {
        x: 0,
        y: 0,
        xCreate: 0,
        yCreate: 0,
    };
}
